exports = module.exports = require("../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".echarts{width:600px;height:400px}", ""]);

// exports
